<template>
  <router-view />
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
@import "~element-ui/lib/theme-chalk/index.css";
@import "~element-ui/lib/theme-chalk/display.css";
@import "~element-ui/lib/theme-chalk/reset.css";
@import "~@fortawesome/fontawesome-free/css/all.css";

// Import Main styles for this application
@import "assets/scss/style";

body {
  margin: 0;
}
</style>
